import React from 'react';

const context = React.createContext({ message: '', type: 'info', show: () => {} });

export const { Provider } = context;
export const { Consumer } = context;
